// extracted by mini-css-extract-plugin
export default {"App":"App_App__w+EhH","container":"App_container__S8THR"};